{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} en {{ moreCount }} meer",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} en {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} bestand",
  "{{ count }} files_other": "{{ count }} bestanden",
  "{{ count }} people are typing_one": "{{ count }} persoon typt",
  "{{ count }} people are typing_many": "{{ count }} personen typen",
  "{{ count }} people are typing_other": "{{ count }} personen typen",
  "{{ count }} photos_one": "{{ count }} foto",
  "{{ count }} photos_other": "{{ count }} foto's",
  "{{ count }} reactions_one": "{{ count }} reactie",
  "{{ count }} reactions_other": "{{ count }} reacties",
  "{{ count }} videos_one": "{{ count }} video",
  "{{ count }} videos_other": "{{ count }} video's",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} en {{ secondUser }}",
  "{{ imageCount }} more": "+{{ imageCount }}",
  "{{ memberCount }} members": "{{ memberCount }} deelnemers",
  "{{ typing }} are typing": "{{ typing }} typen",
  "{{ typing }} is typing": "{{ typing }} typt",
  "{{ user }} has been muted": "{{ user }} is gedempt",
  "{{ user }} has been unmuted": "{{ user }} is niet meer gedempt",
  "{{ user }} is typing...": "{{ user }} is aan het typen...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} en {{ user }} zijn aan het typen...",
  "{{ users }} and more are typing...": "{{ users }} en meer zijn aan het typen...",
  "{{ watcherCount }} online": "{{ watcherCount }} online",
  "{{count}} new messages_one": "{{count}} nieuw bericht",
  "{{count}} new messages_other": "{{count}} nieuwe berichten",
  "{{count}} unread_one": "{{count}} ongelezen",
  "{{count}} unread_other": "{{count}} ongelezen",
  "{{count}} votes_one": "{{count}} stem",
  "{{count}} votes_other": "{{count}} stemmen",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "+{{count}} meer optie",
  "+{{count}} more options_other": "+{{count}} meer opties",
  "🏙 Attachment...": "🏙 Bijlage...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} heeft gemaakt: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} heeft gestemd: {{pollOptionText}}",
  "📍Shared location": "📍Gedeelde locatie",
  "Add a comment": "Voeg een opmerking toe",
  "Add a comment to your poll answer": "Voeg een reactie toe aan je pollantwoord",
  "Add an option": "Voeg een optie toe",
  "Add reaction": "Reactie toevoegen",
  "All results loaded": "Alle resultaten geladen",
  "Allow access to camera": "Toegang tot camera toestaan",
  "Allow access to microphone": "Toegang tot microfoon toestaan",
  "Allow comments": "Sta opmerkingen toe",
  "Allow option suggestion": "Sta optie-suggesties toe",
  "Allow others to add comments": "Sta anderen toe om opmerkingen toe te voegen",
  "Also send as a direct message": "Ook als direct bericht versturen",
  "Also send in channel": "Ook in kanaal versturen",
  "Also sent in channel": "Ook in kanaal verzonden",
  "An error has occurred during recording": "Er is een fout opgetreden tijdens het opnemen",
  "An error has occurred during the recording processing": "Er is een fout opgetreden tijdens de verwerking van de opname",
  "Anonymous": "Anoniem",
  "Anonymous poll": "Anonieme peiling",
  "Archive": "Archief",
  "Are you sure you want to delete this message?": "Weet je zeker dat je dit bericht wilt verwijderen?",
  "aria/Attachment": "Bijlage",
  "aria/Attachment Actions": "Bijlageacties",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "Audiopositie {{ elapsed }} van {{ duration }}",
  "aria/Audio position {{ progress }} percent": "Audiopositie {{ progress }} procent",
  "aria/Block User": "Gebruiker blokkeren",
  "aria/Bookmark Message": "Bericht bookmarken",
  "aria/Cancel recording": "Opname annuleren",
  "aria/Cancel Reply": "Antwoord annuleren",
  "aria/Cancel upload": "Upload annuleren",
  "aria/Channel Actions": "Kanaalacties",
  "aria/Channel list": "Kanaallijst",
  "aria/Channel search results": "Zoekresultaten voor kanalen",
  "aria/Chat view tabs": "Tabbladen chatweergave",
  "aria/Clear search": "Zoekopdracht wissen",
  "aria/Close callout dialog": "Calloutdialoog sluiten",
  "aria/Close thread": "Draad sluiten",
  "aria/Collapse sidebar": "Zijbalk samenklappen",
  "aria/Command Suggestions": "Opdrachtsuggesties",
  "aria/Complete recording": "Opname voltooien",
  "aria/Copy Message Text": "Berichttekst kopiëren",
  "aria/Decrease value": "Waarde verlagen",
  "aria/Delete Message": "Bericht verwijderen",
  "aria/Dismiss notification": "Melding sluiten",
  "aria/Download attachment": "Bijlage downloaden",
  "aria/Edit Message": "Bericht bewerken",
  "aria/Emoji picker": "Emoji kiezer",
  "aria/Emoji Suggestions": "Emoji-suggesties",
  "aria/Exit search": "Zoeken afsluiten",
  "aria/Expand sidebar": "Zijbalken uitvouwen",
  "aria/File input": "Bestandsinvoer",
  "aria/File upload": "Bestand uploaden",
  "aria/Flag Message": "Bericht markeren",
  "aria/Image failed to load": "Afbeelding laden mislukt",
  "aria/Image input": "Afbeelding invoeren",
  "aria/Increase value": "Waarde verhogen",
  "aria/Jump to latest message": "Ga naar laatste bericht",
  "aria/Jump to quoted message": "Ga naar geciteerd bericht",
  "aria/Load More Channels": "Meer kanalen laden",
  "aria/Mark Message Unread": "Markeren als ongelezen",
  "aria/Mark messages as read": "Markeer berichten als gelezen",
  "aria/Menu": "Menu",
  "aria/Message Actions": "Berichtacties",
  "aria/Message from {{ user }},": "Bericht van {{ user }},",
  "aria/Message Options": "Berichtopties",
  "aria/Message,": "Bericht,",
  "aria/Mute User": "Gebruiker dempen",
  "aria/Notifications": "Meldingen",
  "aria/Open Attachment Selector": "Open bijlage selector",
  "aria/Open Channel Actions Menu": "Kanaalactiemenu openen",
  "aria/Open Menu": "Menu openen",
  "aria/Open Message Actions Menu": "Menu voor berichtacties openen",
  "aria/Open Reaction Selector": "Reactiekiezer openen",
  "aria/Open Thread": "Draad openen",
  "aria/Pause": "Pauzeren",
  "aria/Pause recording": "Opname pauzeren",
  "aria/Percent complete": "{{percent}} procent voltooid",
  "aria/Pin Message": "Bericht vastmaken",
  "aria/Play": "Afspelen",
  "aria/Quote Message": "Bericht citeren",
  "aria/Reaction list": "Reactielijst",
  "aria/Remind Me Message": "Herinner mij",
  "aria/Remind Me Options": "Herinneringsopties",
  "aria/Remove attachment": "Bijlage verwijderen",
  "aria/Remove location attachment": "Locatie bijlage verwijderen",
  "aria/Remove option": "Optie verwijderen",
  "aria/Remove Reminder": "Herinnering verwijderen",
  "aria/Remove Save For Later": "Verwijder 'Bewaren voor later'",
  "aria/Resend Message": "Bericht opnieuw verzenden",
  "aria/Resume recording": "Opname hervatten",
  "aria/Retry upload": "Upload opnieuw proberen",
  "aria/Review bounced message": "Controleer teruggestuurd bericht",
  "aria/Search results": "Zoekresultaten",
  "aria/Search results header filter button for: {{ source }}": "Filterknop koptekst zoekresultaten voor: {{ source }}",
  "aria/Seek audio position": "Audiopositie zoeken",
  "aria/Select Channel: {{ channelName }}": "Kanaal selecteren: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "Reactie selecteren: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "Gebruikerskanaal selecteren: {{ name }}",
  "aria/Send": "Verzenden",
  "aria/Show preview": "Voorbeeld tonen",
  "aria/Start recording audio": "Audio-opname starten",
  "aria/Stop AI Generation": "AI-generatie stoppen",
  "aria/Suggestions": "Suggesties",
  "aria/Thread list": "Threadlijst",
  "aria/Unblock User": "Gebruiker deblokkeren",
  "aria/Unmute User": "Dempen opheffen",
  "aria/Unpin Message": "Losmaken",
  "aria/User Suggestions": "Gebruikerssuggesties",
  "Ask a question": "Stel een vraag",
  "Attach": "Bijvoegen",
  "Attach files": "Bijlage toevoegen",
  "Attachment": "Bijlage",
  "Attachment upload blocked due to {{reason}}": "Bijlage upload geblokkeerd vanwege {{reason}}",
  "Attachment upload failed due to {{reason}}": "Bijlage upload mislukt vanwege {{reason}}",
  "Back": "Terug",
  "ban-command-args": "[@gebruikersnaam] [tekst]",
  "ban-command-description": "Een gebruiker verbannen",
  "Block User": "Gebruiker blokkeren",
  "Cancel": "Annuleer",
  "Cannot seek in the recording": "Kan niet zoeken in de opname",
  "Channel archived": "Kanaal gearchiveerd",
  "Channel Missing": "Kanaal niet gevonden",
  "Channel muted": "Kanaal gedempt",
  "Channel pinned": "Kanaal vastgezet",
  "Channel unarchived": "Kanaal uit archief gehaald",
  "Channel unmuted": "Dempen van kanaal opgeheven",
  "Channel unpinned": "Kanaal losgemaakt",
  "Channels": "Kanalen",
  "Chats": "Chats",
  "Choose between 2 to 10 options": "Kies tussen 2 en 10 opties",
  "Close": "Sluit",
  "Close dialog": "Dialoog sluiten",
  "Close emoji picker": "Sluit de emoji-kiezer",
  "Close prompt: {{ title }}": "Prompt sluiten: {{ title }}",
  "Command not available while editing": "Opdracht niet beschikbaar tijdens bewerken",
  "Command not available while replying": "Opdracht niet beschikbaar tijdens beantwoorden",
  "Commands": "Commando's",
  "Commands matching": "Bijpassende opdrachten",
  "Connection failure, reconnecting now...": "Verbindingsfout, opnieuw verbinden...",
  "Copy Message": "Bericht kopiëren",
  "Create": "Maak",
  "Create a question, add options, and configure poll settings": "Maak een vraag, voeg opties toe en stel de pollinstellingen in",
  "Create poll": "Maak peiling",
  "Current location": "Huidige locatie",
  "Delete": "Verwijder",
  "Delete for me": "Voor mij verwijderen",
  "Delete message": "Bericht verwijderen",
  "Delivered": "Afgeleverd",
  "Direct message": "Direct bericht",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "Wil je deze peiling nu beëindigen? Niemand kan daarna meer op deze peiling stemmen.",
  "Download All": "Alles downloaden",
  "Download Attachment": "Bijlage downloaden",
  "Download attachment {{ name }}": "Bijlage {{ name }} downloaden",
  "Drag your files here": "Sleep je bestanden hier naartoe",
  "Drag your files here to add to your post": "Sleep je bestanden hier naartoe om aan je bericht toe te voegen",
  "Due {{ timeLeft }}": "Vervallen in {{ timeLeft }}",
  "Due since {{ dueSince }}": "Vervallen sinds {{ dueSince }}",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit Message": "Bericht bewerken",
  "Edit message request failed": "Verzoek om bericht bewerken mislukt",
  "Edited": "Bewerkt",
  "Emoji matching": "Emoji-overeenkomsten",
  "Empty message...": "Leeg bericht...",
  "End": "Einde",
  "End poll": "Peiling beëindigen",
  "End this poll?": "Peiling beëindigen?",
  "End vote": "Einde stem",
  "Enforce unique vote is enabled": "Unieke stem is ingeschakeld",
  "Error": "Fout",
  "Error adding flag": "Fout bij toevoegen van vlag",
  "Error connecting to chat, refresh the page to try again.": "Fout bij het verbinden, ververs de pagina om nogmaals te proberen",
  "Error deleting message": "Fout bij verwijderen van bericht",
  "Error fetching reactions": "Fout bij het laden van reacties",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "Fout bij markeren van bericht als ongelezen. Kan geen oudere ongelezen berichten markeren dan de nieuwste 100 kanaalberichten.",
  "Error muting a user ...": "Fout bij het muten van de gebruiker",
  "Error pinning message": "Fout bij vastzetten van bericht",
  "Error removing message pin": "Fout bij verwijderen van berichtpin",
  "Error reproducing the recording": "Fout bij het afspelen van de opname",
  "Error starting recording": "Fout bij het starten van de opname",
  "Error unmuting a user ...": "Fout bij het unmuten van de gebruiker",
  "Error uploading attachment": "Fout bij het uploaden van de bijlage",
  "Error uploading file": "Fout bij uploaden bestand",
  "Error uploading image": "Fout bij uploaden afbeelding",
  "Error: {{ errorMessage }}": "Fout: {{ errorMessage }}",
  "Exit command {{ command }}": "Opdracht verlaten {{ command }}",
  "Failed to block user": "Gebruiker blokkeren mislukt",
  "Failed to create the poll": "Fout bij het maken van de peiling",
  "Failed to create the poll due to {{reason}}": "Peiling kon niet worden aangemaakt vanwege {{reason}}",
  "Failed to delete the message": "Bericht verwijderen mislukt",
  "Failed to end the poll": "Peiling kon niet worden beëindigd",
  "Failed to end the poll due to {{reason}}": "Peiling kon niet worden beëindigd vanwege {{reason}}",
  "Failed to jump to the first unread message": "Niet gelukt om naar het eerste ongelezen bericht te springen",
  "Failed to leave channel": "Kanaal verlaten mislukt",
  "Failed to load channels": "Kanalen konden niet worden geladen",
  "Failed to load more channels": "Meer kanalen konden niet worden geladen",
  "Failed to mark channel as read": "Kanaal kon niet als gelezen worden gemarkeerd",
  "Failed to play the recording": "Kan de opname niet afspelen",
  "Failed to retrieve location": "Locatie kon niet worden opgehaald",
  "Failed to share location": "Locatie kon niet worden gedeeld",
  "Failed to update channel archive status": "Archiefstatus van kanaal kon niet worden bijgewerkt",
  "Failed to update channel mute status": "Muteerstatus van kanaal kon niet worden bijgewerkt",
  "Failed to update channel pinned status": "Vastgezette status van kanaal kon niet worden bijgewerkt",
  "File": "Bestand",
  "File is required for upload attachment": "Bestand is vereist voor het uploaden van een bijlage",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "Bestand is te groot: {{ size }}, maximale uploadgrootte is {{ limit }}",
  "File too large": "Bestand is te groot",
  "fileCount_one": "1 bestand",
  "fileCount_other": "{{ count }} bestanden",
  "Flag": "Markeer",
  "Generating...": "Genereren...",
  "giphy-command-args": "[tekst]",
  "giphy-command-description": "Plaats een willekeurige gif in het kanaal",
  "Hide who voted": "Verberg wie heeft gestemd",
  "Image": "Afbeelding",
  "imageCount_one": "Afbeelding",
  "imageCount_other": "{{ count }} afbeeldingen",
  "Instant commands": "Snelle opdrachten",
  "language/af": "Afrikaans",
  "language/am": "Amhaars",
  "language/ar": "Arabisch",
  "language/az": "Azerbeidzjaans",
  "language/bg": "Bulgaars",
  "language/bn": "Bengaals",
  "language/bs": "Bosnisch",
  "language/cs": "Tsjechisch",
  "language/da": "Deens",
  "language/de": "Duits",
  "language/el": "Grieks",
  "language/en": "Engels",
  "language/es": "Spaans",
  "language/es-MX": "Spaans (Mexico)",
  "language/et": "Estlands",
  "language/fa": "Perzisch",
  "language/fa-AF": "Dari",
  "language/fi": "Fins",
  "language/fr": "Frans",
  "language/fr-CA": "Frans (Canada)",
  "language/ha": "Hausa",
  "language/he": "Hebreeuws",
  "language/hi": "Hindi",
  "language/hr": "Kroatisch",
  "language/ht": "Haïtiaans Creools",
  "language/hu": "Hongaars",
  "language/id": "Indonesisch",
  "language/it": "Italiaans",
  "language/ja": "Japans",
  "language/ka": "Georgisch",
  "language/ko": "Koreaans",
  "language/lt": "Litouws",
  "language/lv": "Letlands",
  "language/ms": "Maleis",
  "language/nl": "Nederlands",
  "language/no": "Noors",
  "language/pl": "Pools",
  "language/ps": "Pasjtoe",
  "language/pt": "Portugees",
  "language/ro": "Roemeens",
  "language/ru": "Russisch",
  "language/sk": "Slowaaks",
  "language/sl": "Sloveens",
  "language/so": "Somali",
  "language/sq": "Albanees",
  "language/sr": "Servisch",
  "language/sv": "Zweeds",
  "language/sw": "Swahili",
  "language/ta": "Tamil",
  "language/th": "Thai",
  "language/tl": "Tagalog",
  "language/tr": "Turks",
  "language/uk": "Oekraïens",
  "language/ur": "Urdu",
  "language/vi": "Vietnamees",
  "language/zh": "Chinees (vereenvoudigd)",
  "language/zh-TW": "Chinees (traditioneel)",
  "Leave Channel": "Kanaal verlaten",
  "Left channel": "Kanaal verlaten",
  "Let others add options": "Laat anderen opties toevoegen",
  "Limit votes per person": "Stemmen per persoon beperken",
  "Link": "Link",
  "linkCount_one": "Link",
  "linkCount_other": "{{ count }} links",
  "live": "live",
  "Live for {{duration}}": "Live voor {{duration}}",
  "Live location": "Live locatie",
  "Live until {{ timestamp }}": "Live tot {{ timestamp }}",
  "Load more": "Meer laden",
  "Local upload attachment missing local id": "Lokale uploadbijlage mist lokale id",
  "Location": "Locatie",
  "Location sharing ended": "Locatie delen beëindigd",
  "Location: {{ coordinates }}": "Locatie: {{ coordinates }}",
  "Mark as unread": "Markeren als ongelezen",
  "Maximum number of votes (from 2 to 10)": "Maximaal aantal stemmen (van 2 tot 10)",
  "Maximum votes per person": "Maximum aantal stemmen per persoon",
  "Menu": "Menu",
  "Message deleted": "Bericht verwijderd",
  "Message failed to send": "Bericht kon niet worden verzonden",
  "Message has been successfully flagged": "Bericht is succesvol gemarkeerd",
  "Message marked as unread": "Bericht gemarkeerd als ongelezen",
  "Message pinned": "Bericht vastgezet",
  "Message unpinned": "Bericht losgemaakt",
  "Message was blocked by moderation policies": "Bericht is geblokkeerd door moderatiebeleid",
  "Messages have been marked unread.": "Berichten zijn gemarkeerd als ongelezen.",
  "Missing permissions to upload the attachment": "Missende toestemmingen om de bijlage te uploaden",
  "Multiple votes": "Meerdere stemmen",
  "Mute": "Dempen",
  "mute-command-args": "[@gebruikersnaam]",
  "mute-command-description": "Een gebruiker dempen",
  "network error": "netwerkfout",
  "New": "Nieuwe",
  "New message from {{user}}": "Nieuw bericht van {{user}}",
  "New Messages!": "Nieuwe Berichten!",
  "Next image": "Volgende afbeelding",
  "No chats here yet…": "Nog geen chats hier...",
  "No conversations yet": "Nog geen gesprekken",
  "No items exist": "Er zijn geen items",
  "No results found": "Geen resultaten gevonden",
  "Nobody will be able to vote in this poll anymore.": "Niemand kan meer stemmen in deze peiling.",
  "Nothing yet...": "Nog niets ...",
  "Offline": "Offline",
  "Ok": "Oké",
  "Online": "Online",
  "Only numbers are allowed": "Alleen nummers zijn toegestaan",
  "Only visible to you": "Alleen zichtbaar voor jou",
  "Open emoji picker": "Emoji-kiezer openen",
  "Open gallery at image {{ index }}": "Galerij openen bij afbeelding {{ index }}",
  "Open image in gallery": "Afbeelding openen in galerij",
  "Open location in a map": "Locatie op een kaart openen",
  "Option already exists": "Optie bestaat al",
  "Option is empty": "Optie is leeg",
  "Options": "Opties",
  "Original": "Origineel",
  "People matching": "Mensen die matchen",
  "Photo": "Foto",
  "Pin": "Vastmaken",
  "Pinned by {{ name }}": "Vastgemaakt door {{ name }}",
  "Pinned by You": "Door jou vastgezet",
  "placeholder/PollComment": "Jouw reactie",
  "placeholder/PollOptionSuggestion": "Voer een nieuwe optie in",
  "Play video": "Video afspelen",
  "Playback speed {{ rate }}x": "Afspeelsnelheid {{ rate }}x",
  "Poll": "Peiling",
  "Poll comments": "Peiling opmerkingen",
  "Poll ended": "Peiling beëindigd",
  "Poll options": "Peiling opties",
  "Poll results": "Peiling resultaten",
  "Previous image": "Vorige afbeelding",
  "Question": "Vraag",
  "Question {{ optionOrderNumber}}": "Vraag {{ optionOrderNumber}}",
  "Question is required": "Vraag is verplicht",
  "Quote Reply": "Citaatantwoord",
  "Reached the vote limit. Remove an existing vote first.": "Stemlimiet bereikt. Verwijder eerst een bestaande stem.",
  "Recording format is not supported and cannot be reproduced": "Opnameformaat wordt niet ondersteund en kan niet worden gereproduceerd",
  "Remind me": "Herinner me",
  "Remind Me": "Herinner mij",
  "Reminder set": "Herinnering ingesteld",
  "Remove reminder": "Herinnering verwijderen",
  "Remove save for later": "Verwijder 'Bewaren voor later'",
  "Replied to a thread": "Heeft gereageerd in een thread",
  "Reply": "Antwoord",
  "Reply to {{ authorName }}": "Antwoord aan {{ authorName }}",
  "Reply to a message to start a thread": "Beantwoord een bericht om een thread te starten",
  "Reply to Message": "Antwoord op bericht",
  "replyCount_one": "1 antwoord",
  "replyCount_other": "{{ count }} antwoorden",
  "Resend": "Opnieuw verzenden",
  "Retry upload": "Upload opnieuw proberen",
  "Review all options available in this poll": "Bekijk alle beschikbare opties in deze poll",
  "Review comments submitted with poll answers": "Bekijk reacties die met pollantwoorden zijn ingediend",
  "Review poll results and open an option to see detailed votes": "Bekijk pollresultaten en open een optie om gedetailleerde stemmen te zien",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "Bekijk dit bericht en kies of je het verwijdert, bewerkt of toch verstuurt",
  "Review who voted for this option": "Bekijk wie op deze optie heeft gestemd",
  "Save for later": "Bewaren voor later",
  "Saved for later": "Bewaard voor later",
  "Search": "Zoeken",
  "Search GIFs": "GIF's zoeken",
  "search-results-header-filter-source-button-label--channels": "kanalen",
  "search-results-header-filter-source-button-label--messages": "berichten",
  "search-results-header-filter-source-button-label--users": "gebruikers",
  "Searching for {{ searchSourceType }}...": "Zoeken naar {{ searchSourceType }}...",
  "Searching...": "Zoeken...",
  "searchResultsCount_one": "1 resultaat",
  "searchResultsCount_other": "{{ count }} resultaten",
  "Select a thread to continue the conversation": "Selecteer een thread om het gesprek voort te zetten",
  "Select more than one option": "Selecteer meer dan één optie",
  "Select one": "Selecteer er een",
  "Select one or more": "Selecteer een of meer",
  "Select up to {{count}}_one": "Selecteer tot {{count}}",
  "Select up to {{count}}_other": "Selecteer tot {{count}}",
  "Select your current location and optionally enable live location sharing": "Selecteer je huidige locatie en schakel eventueel live locatiedeling in",
  "Send": "Verstuur",
  "Send a message": "Stuur een bericht",
  "Send a message to start the conversation": "Stuur een bericht om het gesprek te beginnen",
  "Send Anyway": "Toch versturen",
  "Send message request failed": "Verzoek om bericht te verzenden mislukt",
  "Send poll": "Peiling versturen",
  "Sending...": "Aan het verzenden...",
  "Sent": "Verzonden",
  "Share": "Delen",
  "Share live location for": "Live locatie delen voor",
  "Share Location": "Locatie delen",
  "Shared live location": "Gedeelde live locatie",
  "Shared location": "Gedeelde locatie",
  "Shuffle": "Schudden",
  "size limit": "grootte limiet",
  "Slow Mode ON": "Langzame modus aan",
  "Slow mode, wait {{ seconds }}s...": "Langzame modus, wacht {{ seconds }}s...",
  "Slow wait, wait {{ seconds }}s": "Langzame modus, wacht {{ seconds }}s",
  "Slow wait, wait {{ seconds }}s...": "Langzame modus, wacht {{ seconds }}s...",
  "Some of the files will not be accepted": "Sommige bestanden zullen niet worden geaccepteerd",
  "Start typing to search": "Begin met typen om te zoeken",
  "Stop sharing": "Delen stoppen",
  "Submit": "Versturen",
  "Suggest a new option to add to this poll": "Stel een nieuwe optie voor om aan deze poll toe te voegen",
  "Suggest an option": "Stel een optie voor",
  "Tap to remove": "Tik om te verwijderen",
  "Tap to remove: {{ reactionName }}": "Tik om te verwijderen: {{ reactionName }}",
  "Thinking...": "Denken...",
  "this content could not be displayed": "Deze inhoud kan niet weergegeven worden",
  "This field cannot be empty or contain only spaces": "Dit veld mag niet leeg zijn of alleen spaties bevatten",
  "This message did not meet our content guidelines": "Dit bericht voldeed niet aan onze inhoudsrichtlijnen",
  "Thread": "Draadje",
  "Thread has not been found": "Draadje niet gevonden",
  "Thread reply": "Draadje antwoord",
  "Thread Reply": "Draadje antwoord",
  "ThreadListUnseenThreadsBanner/loading": "Laden...",
  "ThreadListUnseenThreadsBanner/unreadThreads_one": "{{ count }} ongelezen thread",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }} ongelezen threads",
  "Threads": "Discussies",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Gisteren]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Vandaag]\", \"nextDay\": \"[Morgen]\", \"lastDay\": \"[Gisteren]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[Laatste] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }}d ago",
  "timestamp/relativeToday": "Vandaag",
  "timestamp/relativeWeeksAgo": "{{ count }}w ago",
  "timestamp/relativeYesterday": "Gisteren",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[Today] [at] HH:mm\", \"nextDay\": \"[Tomorrow] [at] HH:mm\", \"lastDay\": \"[Yesterday] [at] HH:mm\", \"nextWeek\": \"dddd [at] HH:mm\", \"lastWeek\": \"[Last] dddd [at] HH:mm\", \"sameElse\": \"ddd, D MMM [at] HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "Om te beginnen met opnemen, sta toegang tot de camera toe in uw browser",
  "To start recording, allow the microphone access in your browser": "Om te beginnen met opnemen, sta toegang tot de microfoon toe in uw browser",
  "totalVoteCount_one": "1 stem in totaal",
  "totalVoteCount_other": "{{ count }} stemmen in totaal",
  "Translated": "Vertaald",
  "Translated from {{ language }}": "Vertaald uit {{ language }}",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "Typ een getal van 2 tot 10",
  "Unarchive": "Uit archief halen",
  "unban-command-args": "[@gebruikersnaam]",
  "unban-command-description": "Een gebruiker debannen",
  "Unblock User": "Gebruiker deblokkeren",
  "unknown error": "onbekende fout",
  "Unmute": "Dempen opheffen",
  "unmute-command-args": "[@gebruikersnaam]",
  "unmute-command-description": "Een gebruiker niet meer dempen",
  "Unpin": "Losmaken",
  "Unread messages": "Ongelezen berichten",
  "Unsupported attachment": "Niet-ondersteunde bijlage",
  "unsupported file type": "niet-ondersteund bestandstype",
  "Update": "Bijwerken",
  "Update the comment attached to your poll answer": "Werk de reactie bij die aan je pollantwoord is toegevoegd",
  "Update your comment": "Werk je opmerking bij",
  "Upload blocked": "Upload geblokkeerd",
  "Upload error": "Uploadfout",
  "Upload failed": "Upload mislukt",
  "Upload type: \"{{ type }}\" is not allowed": "Uploadtype: \"{{ type }}\" is niet toegestaan",
  "User blocked": "Gebruiker geblokkeerd",
  "User unblocked": "Gebruiker gedeblokkeerd",
  "User uploaded content": "Gebruikersgeüploade inhoud",
  "Video": "Video",
  "videoCount_one": "Video",
  "videoCount_other": "{{ count }} video's",
  "View": "Bekijken",
  "View {{count}} comments_one": "Bekijk {{count}} opmerkingen",
  "View {{count}} comments_other": "Bekijk {{count}} opmerkingen",
  "View all": "Alles bekijken",
  "View original": "Origineel bekijken",
  "View results": "Bekijk resultaten",
  "View translation": "Vertaling bekijken",
  "Voice message": "Spraakbericht",
  "Voice message {{ duration }}": "Spraakbericht {{ duration }}",
  "Voice message deleted": "Spraakbericht verwijderd",
  "voiceMessageCount_one": "Spraakbericht",
  "voiceMessageCount_other": "{{ count }} spraakberichten",
  "Vote ended": "Stemmen beëindigd",
  "Votes": "Stemmen",
  "Wait until all attachments have uploaded": "Wacht tot alle bijlagen zijn geüpload",
  "Waiting for network…": "Wachten op netwerk…",
  "You": "Jij",
  "You've reached the maximum number of files": "Je hebt het maximale aantal bestanden bereikt"
}
